import PropTypes from 'prop-types';
import { useState } from 'react';

// mantine
import { NavLink, Text } from '@mantine/core';

// project imports
import NavItem from '../NavItem';

import { radius, semanticColors } from 'theme';

// ==============================|| SIDEBAR MENU LIST COLLAPSE ITEMS ||============================== //

const NavCollapse = ({ menu, level }) => {
  const [open, setOpen] = useState(false);
  const [selected, setSelected] = useState(null);

  const handleClick = () => {
    setOpen(!open);
    setSelected(!selected ? menu.id : null);
  };

  // menu collapse & item
  const menus = menu.children?.map((item) => {
    switch (item.type) {
      case 'collapse':
        return <NavCollapse key={item.id} menu={item} level={level + 1} />;
      case 'item':
        return <NavItem key={item.id} item={item} level={level + 1} />;
      default:
        return (
          <Text key={item.id} c="red" ta="center" size="sm">
            Menu Items Error
          </Text>
        );
    }
  });

  const Icon = menu.icon;

  return (
    <NavLink
      label={menu.title}
      description={menu.caption || undefined}
      leftSection={
        Icon ? (
          <Icon size={20} stroke={1.5} color={semanticColors.text.primary} />
        ) : (
          <span
            style={{
              width: selected === menu.id ? 8 : 6,
              height: selected === menu.id ? 8 : 6,
              borderRadius: '50%',
              backgroundColor: semanticColors.text.muted,
              display: 'inline-block'
            }}
          />
        )
      }
      opened={open}
      onClick={handleClick}
      style={{
        borderRadius: radius.control,
        marginBottom: 4,
        paddingLeft: level * 24
      }}
      styles={{
        label: {
          fontWeight: selected === menu.id ? 600 : 400
        },
        children: {
          position: 'relative',
          paddingLeft: 0,
          '&::after': {
            content: '""',
            position: 'absolute',
            left: 32,
            top: 0,
            height: '100%',
            width: 1,
            opacity: 1,
            backgroundColor: 'var(--mantine-color-coral-2)'
          }
        }
      }}
      variant="subtle"
      color="gray"
    >
      {menus}
    </NavLink>
  );
};

NavCollapse.propTypes = {
  menu: PropTypes.object,
  level: PropTypes.number
};

export default NavCollapse;
